export enum PinnedEntities {
  DataViews = 'DataViews',
  GenericView = 'GenericView',
  Reports = 'Report',
  UserCollections = 'UserCollections',
  SharedCollections = 'SharedCollections',
  UserQueries = 'UserQueries',
  UnTyped = 'UnTyped',
  Module = 'Module',
}
